import React from 'react';
import { Typography, NavigationHeadIcon } from '../../index';

export const NavigationHead = ({
    active, // nav head accordion menu is open
    className,
    disabled,
    icon,
    label,
    selected, // nav head url matches and is selected
}) => {

    const navHeadStatus = disabled
        ? 'disabled' : active
            ? 'active' : selected
                ? 'selected' : 'default';

    const textColor = {
        active: '$color-primary-a2',
        default: '',
        disabled: selected ? '$color-secondary-a3' : '$color-secondary-a4',
        selected: '$color-primary-a3'
    };

    const iconColor = (active || selected) ? '$color-primary-a3' : '$color-secondary-a2';

    const navHeaderClasses = [
        `bsw-navigation__header`,
        `${disabled ? 'bsw-navigation__header--disabled' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <div data-container="MenuHeadItem" className={navHeaderClasses}>
            <Typography
                type="body-02"
                bold={active || selected}
                color={textColor[navHeadStatus]}
            >
                {icon && <NavigationHeadIcon icon={icon} color={iconColor} disabled={disabled} />}
                {label && <span className="bsw-navigation__header-label">{label}</span>}
            </Typography>
        </div>
    );

}
